import { Helper } from '../../js/helpers/Helper';


/**
 * MegamenuAjaxSearch Class
 */
class MegamenuAjaxSearch {

	/**
	 * Constructor
	 *
	 * @param {HTMLElement} block
	 * @return {void}
	 */
	constructor( block ) {

		this.block = block;

		if ( !this.block ) {

			return;

		}

		this.breakpointMobile = 1280;
		this.mediaQuerySmallMobile = window.matchMedia(
			`(max-width:${this.breakpointMobile}px)`
		);

		this.search = block.querySelector( '.js-search' );
		this.parentSearchToggle = block.querySelector(
			'.b-megamenu-search__toggle'
		);

		this.searchToggle = block.querySelector( '.js-search-toggle' );
		this.closeButton = block.querySelector( '.js-search-close-bar' );
		this.searchContainer = block.querySelector( '.js-search-container' );
		this.searchInput = block.querySelector( '.js-search-input' );
		// this.megamenu = this.block.closest( '.b-header' );
		this.megamenuContainer = this.block.closest( '.b-main-nav' );

		this.addEvents();
		document.addEventListener( 'click', this.handleDocumentClick );

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		this.closeButton.addEventListener( 'click', this.handleCloseBar );
		this.searchToggle.addEventListener( 'click', this.clickedHandler );
		this.searchToggle.addEventListener( 'keyup', this.keyupHandler );
		this.searchToggle.addEventListener( 'focusout', this.resetFocus );
		this.searchInput.addEventListener( 'focus', this.focusInputHandler );
		this.searchInput.addEventListener( 'blur', this.focusInputHandler );

	}

	/**
	 * Handles the click event on the document.
	 * If the search container is opened and the click target
	 * is not within a specific block, closes the search bar.
	 *
	 * @param {Event} e - The click event
	 */
	handleDocumentClick = ( e ) => {

		if (
			this.searchContainer.classList.contains(
				'js-header-searchbar--opened'
			) &&
			!this.block.contains( e.target )
		) {

			this.closeBar();

		}

	};

	/**
	 * showBar
	 *
	 * @return {void}
	 */
	showBar() {

		this.searchContainer.classList.add( 'js-header-searchbar--opened' );
		this.searchContainer.classList.toggle( 'is-active' );

	}

	/**
	 * closeBar
	 *
	 * @return {void}
	 */
	closeBar() {

		Helper.removeClassFromEl( this.searchContainer, 'is-active' );
		this.searchContainer.classList.remove( 'js-header-searchbar--opened' );

	}

	/**
	 * Handles closing the search bar within the header.
	 * If the search container has the CSS class 'js-header-searchbar--opened', it will close the search bar.
	 */
	handleCloseBar = () => {

		if (
			this.searchContainer.classList.contains(
				'js-header-searchbar--opened'
			)
		) {

			this.closeBar();

		}

	};

	/**
	 * clickedHandler
	 */
	clickedHandler = () => {

		if ( this.searchContainer && this.searchInput ) {

			this.showBar();
			this.searchInput.focus();

		}

	};

	/**
	 * keyupHandler
	 * @param {object} e
	 */
	keyupHandler = ( e ) => {

		this.resetFocus();
		Helper.addClassToEl( e.target.parentNode, 'js-focus' );

	};

	/**
	 * resetFocus
	 *
	 * @return {void}
	 */
	resetFocus = () => {

		Helper.removeClassFromEl( this.searchToggle.parentNode, 'js-focus' );

	};

	/**
	 * focusInputHandler
	 * @param {object} e
	 * @return {void}
	 */
	focusInputHandler = ( e ) => {

		if ( e.type === 'focus' ) {

			this.searchInput.closest( '.js-search' ).classList.add( 'is-active' );

		}
		if ( e.type === 'blur' ) {

			this.searchInput
				.closest( '.js-search' )
				.classList.remove( 'is-active' );

		}

	};

}

document.querySelectorAll( '.b-megamenu-search' ).forEach( ( block ) => {

	new MegamenuAjaxSearch( block );

} );
